// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  instanceId: __t.u64().primaryKey().name("instance_id"),
  worldId: __t.u64().name("world_id"),
  outcomeRow: __t.u8().name("outcome_row"),
  settledAt: __t.timestamp().name("settled_at"),
  xpEach: __t.u32().name("xp_each"),
  goldEach: __t.u32().name("gold_each"),
});
